import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  --sectionBackground: transparent;
  --sectionColour: ${brand.blue.navy};
  --sectionTitleColour: ${brand.blue.dark};

  scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;
  color: var(--sectionColour);
  background-color: var(--sectionBackground);

  /* Background.Beige */
  &[data-background='beige'] {
    --sectionBackground: ${brand.global.beige};
  }

  /* Background.Blue */
  &[data-background='light-blue'] {
    --sectionBackground: ${brand.blue.light};
  }

  /* Background.Green */
  &[data-background='light-green'] {
    --sectionBackground: ${brand.green.light};
  }

  /* Background.Grey */
  &[data-background='grey'] {
    --sectionBackground: ${brand.grey.background};
  }

  /* Background.Navy */
  &[data-background='navy'] {
    --sectionColour: ${brand.global.white};
    --sectionBackground: ${brand.blue.navy};
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const FocusAnchor = styled.button `
  ${ButtonReset};

  height: 0;
  width: 0;
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    FocusAnchor,
};
export default SectionWrapperStyles;
